<template>


<TopBar />

<div class="main-container">

<SideBar />

<div class="main"> 


<section>

<div class="container" style="border-bottom: solid 1px #f0f0f0; padding-top: 10px; padding-bottom: 10px;">

<div class="row">

<div class="col-md-6 pt-3">
<h3> <i class="bi bi-cpu color-1"></i> Devices</h3>
</div>



</div>

</div>

</section>


<section style="padding-top:200px;" v-if="show_spinner==true">

<div style="text-align:center;">

<h6 class="text-secondary">Loading devices...</h6>
<div class="spinner-border  text-info"></div>
</div>

</section>



<section v-if="show_spinner==false">
  
<div class="container">

    <div class="row">

    <div class="col-md-12">

      <div class="shadow  p-3 mt-3" style="border: solid 1px  #d7f1ff; border-radius: 15px; ">

       
       <div style="border-bottom: solid 1px #f0f0f0; padding-bottom:10px;">
          <div class="row">

          <div class="col-md-8 col-6">
            <h6 class="text-secondary hide-me"><span>ID:</span> {{device_id}}</h6>
          </div>

          <div class="col-md-4 col-6" style="text-align:right;">
            <h6> <i class="bi bi-dot text-success blink"></i> <span class="badge badge-success">Online</span> </h6>
          </div>
          
        </div>
       </div>



       <div>
         
         <div class="row">

          <div class="col-md-4" style="text-align:center; padding-top: 20px; border-right: solid 1px #f0f0f0; border-top: solid 1px #f0f0f0; ">
            <h6 class="color-1"> <i class="bi bi-phone"></i> </h6>
            <h6 class="text-secondary">Device Address</h6>
            <h6>{{device_address}}</h6>
            
          </div>


           <div class="col-md-4" style="text-align:center; padding-top: 20px; border-right: solid 1px #f0f0f0; border-top: solid 1px #f0f0f0; ">
            <h6 class="color-1"> <i class="bi bi-reception-3 blink"></i> </h6>
            <h6 class="text-secondary">Signal Strength</h6>
            <h6>{{signal_strength}} dBm</h6>
            
          </div>


          <div class="col-md-4" style="text-align:center; padding-top: 20px; border-top: solid 1px #f0f0f0;  ">
            <h6 class="color-1"> <i class="bi bi-geo-alt"></i> </h6>
            <h6 class="text-secondary">Location</h6>
            <h6>The Tiigo school</h6>
            
          </div>

          <div class="col-md-4" style="text-align:center; padding-top: 20px; border-right: solid 1px #f0f0f0; border-top: solid 1px #f0f0f0;  ">
            <h6 class="color-1"> <i class="bi bi-gear"></i> </h6>
            <h6 class="text-secondary">Device EUI</h6>
            <h6>{{dev_eui}}</h6>
            
          </div>

          <div class="col-md-4" style="text-align:center; padding-top: 20px; border-right: solid 1px #f0f0f0; border-top: solid 1px #f0f0f0;  ">
            <h6 class="color-1"> <i class="bi bi-activity"></i> </h6>
            <h6 class="text-secondary">Join EUI</h6>
            <h6>{{join_eui}}</h6>
            
          </div>


          <div class="col-md-4" style="text-align:center; padding-top: 20px; border-top: solid 1px #f0f0f0;  ">
            <h6 class="color-1"> <i class="bi bi-app-indicator"></i> </h6>
            <h6 class="text-secondary">SNR</h6>
            <h6>{{snr}}</h6>
            
          </div>


           <div class="col-md-4" style="text-align:center; padding-top: 20px; border-top: solid 1px #f0f0f0; border-right: solid 1px #f0f0f0;  ">
            <h6 class="color-1"> <i class="bi bi-crosshair"></i> </h6>
            <h6 class="text-secondary">Spreading Factor</h6>
            <h6>{{spreading_factor}}</h6>
            
          </div>


           <div class="col-md-4" style="text-align:center; padding-top: 20px; border-top: solid 1px #f0f0f0; border-right: solid 1px #f0f0f0;  ">
            <h6 class="color-1"> <i class="bi bi-wifi"></i> </h6>
            <h6 class="text-secondary">Bandwidth</h6>
            <h6>{{bandwidth}}</h6>
            
          </div>
          
           <div class="col-md-4" style="text-align:center; padding-top: 20px; border-top: solid 1px #f0f0f0;  ">
            <h6 class="color-1"> <i class="bi bi-phone-vibrate"></i> </h6>
            <h6 class="text-secondary">Coding Rate</h6>
            <h6>{{coding_rate}}</h6>
            
          </div>
           
         </div>

       </div>

        
      </div>
      
    </div>








         <div class="col-md-12">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
          Signal Strength Trends
        </h6>


        <CanvasJSChart :options="signal_strength_trends" />

       </div> 

        </div>




    
  </div>

  
  
  
</div>

</section>




</div>




</div>


<Footer />

</template>



<script>

import Header from './layouts/Header'
import SideBar from './layouts/SideBar'
import TopBar from './layouts/TopBar'
import Footer from './layouts/Footer'
import axios from 'axios'

export default{
name : 'home',
components : { Header, SideBar, TopBar, Footer  },
data(){
return{
show_spinner : true,
today_data : [],
show_spinner : true,
all_data : [],
signal_strength : 0,
device_address : 0,
device_id : 0,
dev_eui : 0,
join_eui : 0,
snr : 0,
spreading_factor : '',
bandwidth : '',
coding_rate : '',
signal_strength_trends : []
}
},

methods : {


  to_date_time(date_time) {
   const date = new Date(date_time);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date input");
  }

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 becomes 12

  return `${hours}:${minutes} ${ampm}`;
},



get_today_date(){
const today = new Date();
today.setDate(today.getDate());

const year = today.getFullYear();
const month = String(today.getMonth() + 1).padStart(2, '0');
const day = String(today.getDate()).padStart(2, '0');

const formatted = `${year}-${month}-${day}`;

return formatted
},

  convert_to_date_only(date_time){
    try{
      const dt = new Date(date_time)
const dateOnly = dt.toISOString().split('T')[0]
return dateOnly
    }catch(error){

    }
},

async get_data() {

  this.show_spinner = true


try {
const response = await axios.get('https://weather-data-marsabit-default-rtdb.firebaseio.com/.json')
const dataObject = response.data.weather_data
const dataArray = Object.values(dataObject)
const today_raw_data = dataArray.slice(-1) //get last one

const all_data = dataArray

const all_raw_data = dataArray




//get todays latest data 
today_raw_data.forEach((data)=>{
this.today_data = data 
})

//deveice address
this.device_address = this.today_data.end_device_ids.dev_addr

//device id
this.device_id = this.today_data.end_device_ids.device_id
this.dev_eui = this.today_data.end_device_ids.dev_eui
this.join_eui = this.today_data.end_device_ids.join_eui


//rx_metadata
let rx_metadata = []
today_raw_data.forEach((data)=>{
rx_metadata = data.uplink_message.rx_metadata
 
})


//signal strength trends 
let signal_strength_trends = []
all_data.forEach((data)=>{
signal_strength_trends.push(data.uplink_message.rx_metadata)
 
})


let signal_strength_trends_cleaned = []

signal_strength_trends.forEach((data)=>{
  
  if(this.get_today_date()==this.convert_to_date_only(data[0].received_at)){
    signal_strength_trends_cleaned.push( { 'y' : data[0].channel_rssi, 'label' : this.to_date_time(data[0].received_at) } )

  }
  

})




this.signal_strength_trends = {
        animationEnabled: true,
        title:{
      text: ""
        },
        data: [{
          type: "line",
          dataPoints: signal_strength_trends_cleaned
        }]
      }



//settings
today_raw_data.forEach((data)=>{
  this.spreading_factor = data.uplink_message.settings.data_rate.lora.spreading_factor
  this.coding_rate = data.uplink_message.settings.data_rate.lora.coding_rate
  this.bandwidth = data.uplink_message.settings.data_rate.lora.bandwidth
})





if(rx_metadata.length>0){
  rx_metadata.forEach((data)=>{
    this.signal_strength = data.channel_rssi
    this.snr = data.snr
    
  })
}
//



this.show_spinner = false


}catch (error) {
console.log(error)
}

}


},

created(){

this.get_data()


}


}

</script>




<style>
  .blink {
  animation: blink-animation 1s steps(2, start) infinite;
  transition: 0.4s;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>

